import React from 'react';
import { Switch, Route } from 'react-router-dom';
import LoginPage from 'components/Login/LoginPage';
import NoticePage from 'components/Notice/NoticePage';
import ExamplePage from 'components/Example/ExamplePage';
import QuestionPage from 'components/Question/QuestionPage';
import CompletePage from 'components/Complete/CompletePage';
import DataImport from 'components/DataImport/DataImport';
import { Container } from 'semantic-ui-react';
import Admin from './Admin';

const App: React.FC = () => {
  return (
    <>
      <Container fluid style={{ minWidth: '900px', minHeight: '100vh', position: 'relative', paddingBottom: '20px' }}>
        <Switch>
          <Route exact path="/">
            <LoginPage />
          </Route>
          <Route path="/notice">
            <NoticePage />
          </Route>
          <Route path="/example">
            <ExamplePage />
          </Route>
          <Route path="/question">
            <QuestionPage />
          </Route>
          <Route path="/complete">
            <CompletePage />
          </Route>
          <Route path="/admin">
            <Admin />
          </Route>
          <Route exact path="/dataimport">
            <DataImport />
          </Route>
        </Switch>
      </Container>
    </>
  );
};

export default App;
